import { clsx } from 'clsx';

interface ISearchMenuItemProps {
  label: string;
  isDisabled?: boolean;
  isSelected?: boolean;
  onSelectItem?: () => void;
}

export function SearchMenuItem({ label, isDisabled, isSelected, onSelectItem }: ISearchMenuItemProps) {
  return (
    <div
      data-testid={`${label.replace(/[ \/]/g, '-').toLowerCase()}-type-search`}
      className={clsx(
        'flex items-center duration-200 justify-center px-4 py-[6px] rounded-100 border-2 group',
        isDisabled
          ? 'cursor-auto border-disabled'
          : isSelected
            ? 'cursor-pointer bg-secondary border-interactive'
            : 'cursor-pointer bg-primary border-primary hover:border-interactive hover:bg-secondary',
      )}
      onClick={() => !isDisabled && onSelectItem?.()}
    >
      <span
        className={clsx(
          'typo-body-semibold-small',
          isDisabled
            ? 'text-disabled'
            : isSelected
              ? 'text-interactive'
              : 'text-secondary  group-hover:text-interactive',
        )}
      >
        {label}
      </span>
    </div>
  );
}
